module.exports = __webpack_public_path__ + "static/media/EuclidCircularB-Light.691992a6.woff2";